import React, { useCallback, useEffect, useState } from "react";
import { debounce } from "lodash";
import { getUserDetails } from "services";
import { useTranslation } from "react-i18next";

export function useWorkerDetails(workerId) {
  const { t } = useTranslation();
  const [workerFields, setWorkerFields] = useState({
    workerName: "",
    workerEmail: "",
    workerCountry: "",
  });
  const [empisActive, setEmpisActive] = useState(true);
  const [wasFetched, setWasFetched] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const fetchWorker = useCallback(
    debounce(async (id) => {
      console.log("id test", id)
      if (!id) return;
      setLoading(true);
      setError("");
      try {
        await getUserDetails(id).then((details) => {
          const empDetails = details.data();
          if (!empDetails) {
            setError("Worker id not found");
             setWorkerFields({
              workerName: "",
              workerEmail: "",
              workerCountry: "",
            });
            return;
          }
          if (!empDetails?.isActiveWorker) {
            setError("worker is inactive");
             setWorkerFields({
              workerName: "",
              workerEmail: "",
              workerCountry: "",
            });
            return;
          }
          console.log("Fetched worker data: ", empDetails);
          setWorkerFields({
            workerName: `${empDetails.firstName || ""} ${
              empDetails.lastName || ""
            }`,
            workerEmail: empDetails.email || "",
            workerCountry: empDetails.country || "",
          });
          setWasFetched(true);
          if (empDetails?.isActiveWorker === true) {
            setEmpisActive(true);
          } else {
            setError("Worker is Inactive")
            setEmpisActive(false);
          }
        });
      } catch (error) {
        console.log("error ::", error);
        setError("Please try sometime later")
        setWorkerFields({
          workerName: "",
          workerEmail: "",
          workerCountry: "",
        });
        setWasFetched(false);
        setEmpisActive(false)
      } finally {
        setLoading(false);
      }
    }, 1000),
    []
  );

  // useEffect(() => {
  //   if (workerId && workerId.trim()) {
  //     fetchWorker(workerId.trim());
  //   } else {
  //     setWorkerFields({
  //       workerName: "",
  //       workerEmail: "",
  //       workerCountry: "",
  //     });
  //     setError("");
  //   }
  //   return () => fetchWorker.cancel();
  // }, [workerId, fetchWorker]);

  useEffect(() => {
    const trimmedId = workerId?.trim();
    if (!trimmedId || trimmedId.length < 6) {
      setWorkerFields({
        workerEmail: "",
        workerCountry: "",
        workerName: "",
      });
      setError("")
      setWasFetched(false);
      fetchWorker.cancel();
      return;
    }
    fetchWorker(trimmedId);
    return () => fetchWorker.cancel();
  }, [workerId, fetchWorker]);

  return { workerFields, loading, error, wasFetched, empisActive };
}

export default useWorkerDetails;
